(() => {
  const product = document.querySelector('[id^="product-info-"]');
  if (!product) return;
  let scheduled = false;
  const update = () => {
    scheduled = false;
    const button = product.querySelector('#klaviyo-bis-button-container button');
    const ready = Boolean(
      button &&
      !button.disabled &&
      button.getClientRects().length &&
      getComputedStyle(button).visibility === "visible" &&
      (!button.checkVisibility || button.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true }))
    );
    document.documentElement.classList.toggle("kd-native-restock-ready", ready);
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  };
  new MutationObserver(schedule).observe(product, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["style", "class", "hidden", "disabled", "aria-hidden"]
  });
  window.addEventListener("resize", schedule, { passive: true });
  window.addEventListener("pageshow", schedule);
  update();
})();
